import fly from "../config/flyio";
import urlConstantJs from '../config/ConstantConfig'

export default {
  /**
   * 获取 Referral Link 和附加信息
   * @param {*} param 加密参数
   * @returns
   */
  getReferralLinkTokenByParam(param) {
    return fly.post(`/Token/ReferralLink?p=${param}`);
  },

  /**
   * Get Token For BX（Corp Web Site）
   * @param {*} uuid uuid can be null
   * @returns 
   */
  getTokenByUUID(uuid) {
    return fly.get(`/Token`);
  },

  /**
   * Get Login Status By Token
   * @returns 
   */
  getStatusByToken() {
    return fly.get("/Token/Status");
  },

  /**
   * Valid duplicate token
   * @param {*} token1 
   * @param {*} token2 
   */
  validToken(token1, token2) {
    return fly.post(`/Token/Valid`, { token1: token1, token2: token2 });
  },

  /**
   * Get Login Status By BX
   * @returns 
   */
  getStatusByBX() {
    return fly.request(
      "/VHISLoveYourSelf/GetSmartClubStatus",
      null,
      {
        method: "GET",
        baseURL: `${urlConstantJs.navURL}/ch/`,
        parseJson: true,
        timeout: 1000 * 30 
      }
    )
  }
};
